import React from 'react'

export default function CompleteSVG() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
            <path stroke="#09D77E" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18.333 9.233V10c-.001 1.797-.583 3.546-1.66 4.985-1.075 1.44-2.588 2.492-4.31 3.002-1.724.51-3.566.448-5.252-.175-1.685-.623-3.124-1.774-4.103-3.281-.978-1.508-1.442-3.291-1.324-5.084.118-1.793.813-3.5 1.98-4.866C4.833 3.215 6.41 2.263 8.164 1.867c1.753-.396 3.587-.215 5.228.516" />
            <path stroke="#09D77E" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18.333 3.333L10 11.675l-2.5-2.5" />
        </svg>
    )
}